/* eslint-disable no-restricted-globals */
import { throttle } from 'throttle-debounce';

/**
 *
 * @param tooltipsSelector
 * @param tooltipTextAttribute
 * @param className
 * @param marginLeft
 * @param marginTop
 * @constructor
 */
const Tooltip = ({
  tooltipsSelector = '[data-tooltip]',
  tooltipTextAttribute = 'data-text',
  className = 'Tooltip',
  marginLeft = 10,
  marginTop = 20,
}) => {
  const tooltips = document.querySelectorAll(tooltipsSelector);
  if (!tooltips || isNaN(marginLeft) || isNaN(marginTop)) return;

  [].slice.call(tooltips).forEach((item) => {
    const tooltipText = item.getAttribute(tooltipTextAttribute);
    if (!tooltipText) return;

    const tooltipBody = document.createElement('div');
    tooltipBody.classList.add(className);
    tooltipBody.insertAdjacentHTML('afterbegin', tooltipText);

    let X = 0;
    let Y = 0;

    const throttled = throttle(50, () => {
      tooltipBody.style.left = `${X + marginLeft}px`;
      tooltipBody.style.top = `${Y + marginTop}px`;
    });

    item.addEventListener('mouseover', () => {
      item.appendChild(tooltipBody);
    }, false);

    item.addEventListener('mousemove', (e) => {
      X = e.clientX;
      Y = e.clientY;

      throttled();
    }, false);

    item.addEventListener('mouseout', () => {
      if (tooltipBody) item.removeChild(tooltipBody);
    }, false);
  });
};

export default Tooltip;
